// extracted by mini-css-extract-plugin
export var smallSpinner = "_q7-0";